<template>
    <section class="filters">
        <div class="container">
            <div class="content-wrapper">
                <custom-select
                        v-show="breakpointDownMd"
                        :options="filters"
                        label-field="titre_court"
                        value-field="slug"
                        v-model="activeFilter"
                        @change="selectFilter"
                ></custom-select>
                <ul class="filters" v-show="!breakpointDownMd">
                    <li v-for="filter in filters">
                        <a href="" :class="[filter.slug, {active : filter.slug === activeFilter}]"
                           @click.prevent="goToSection(filter)"><span>{{filter.titre_court}}</span></a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    import Scrolling from "../libs/Scrolling"
    import {find} from "lodash"
    import {breakpoint, breakpointDown, breakpointUp} from "../libs/Breakpoints";
    import {throttle} from "lodash"
    import ScrollMagic from "scrollmagic"
    import Sticky from "sticky-js"
    import $ from "jquery"

    export default {
        props: {
            filters: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                activeFilter: null,
                controller: new ScrollMagic.Controller(),
                sceneArray: [],
                dockFiltersDuration: null,
                filterOnTop: true,
                filtersSticky: null
            };
        },
        computed: {
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            goToSection(filter) {
                Scrolling.scrollTo("#" + filter.slug)
                this.$router.push({hash: filter.slug})
            },
            initScrollHash() {
                if (this.$route.hash) {
                    let hash = this.$route.hash;
                    hash = hash.substr(1);
                    Scrolling.scrollTo(this.$route.hash)

                    this.activeFilter = find(this.filters, (o, index) => {
                        return o.slug === hash
                    });

                    // this.updateClasses(this.activeFilter.slug)

                }
            },
            updateClasses(hash) {
                console.log(hash)
                $("ul.filters a").removeClass("active")
                this.$nextTick(() => {
                    $("ul.filters a." + hash).addClass("active")
                })

            },
            stickyFilters() {

                var marginTop = 0
                if (breakpointDown("md")) {
                    marginTop = Scrolling.hauteurMenuMobile
                }

                this.filtersSticky = new Sticky("section.filters", {
                    marginTop: marginTop,
                    stickyClass: "shadow",
                    wrap: true
                });

            },

            resizeEndHandle() {

                try {
                    this.cleanSpan(this.filtersSticky)
                } catch (e) {
                }

                try {
                    this.filtersSticky.destroy()
                } catch (e) {
                }


                this.stickyFilters()

            },
            cleanSpan(stickyInstance) {
                stickyInstance.elements.forEach(function (element) {
                    if ($(element).parent().is("span")) {
                        $(element).unwrap()
                    }
                });

                $(".sm-start-duration").removeAttr("style")
            },
            initLinksFollow() {

                // Toggle Class Menu Nav
                $(".sm-item").each((index, item) => {

                    let itemName = $(item).attr("id");

                    this.sceneArray[itemName] = new ScrollMagic.Scene({
                        triggerElement: "#" + itemName,
                        triggerHook: 0,
                        duration: $("#" + itemName).outerHeight(true),
                        offset: -$("section.filters").outerHeight(true)
                    })
                    // .addIndicators()
                        .on("enter", (e) => {
                            this.activeFilter = itemName
                        })
                        .on("leave", function (e) {
                            /*                            if (e.scrollDirection === "REVERSE" && e.state === "BEFORE" && $(e.currentTarget.triggerElement()).hasClass("points-cles")) {
                                                            $(".dock-filters .points-cles").addClass("active")
                                                        }*/
                        })

                        .addTo(this.controller);

                });

            },
            selectFilter() {
                Scrolling.scrollTo("#" + this.activeFilter)
                this.$router.push({hash: this.activeFilter})
            }
        },
        created() {
            this.activeFilter = this.filters[0].slug
        },
        mounted() {
            setTimeout(() => {
                this.initScrollHash()
            }, 300)

            setTimeout(() => {
                this.stickyFilters()
            }, 1000);

            this.initLinksFollow()
            $(window).bind("resizeEnd", this.resizeEndHandle);

        },
        beforeDestroy() {

            for (var key in this.sceneArray) {
                this.sceneArray[key].destroy(true)
            }
            this.controller.destroy(true)

            try {
                this.cleanSpan(this.filtersSticky)
            } catch (e) {
            }

            try {
                this.filtersSticky.destroy()
            } catch (e) {
            }

            $(window).unbind("resizeEnd", this.resizeEndHandle);

        }
    };
</script>
